import _ from 'lodash';

import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class NominaTotalesCalculator {

  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new NominaTotalesCalculator(data);
  }

  get() {
    const totalPercepciones = this.getTotalPercepciones();
    const totalDeducciones = this.getTotalDeducciones();
    const totalOtrosPagos = this.getTotalOtrosPagos();

    return {
      totalPercepciones,
      totalDeducciones,
      totalOtrosPagos,
    }
  }

  getTotalPercepciones() {
    // Suma de los campos TotalSueldos más TotalSeparacionIndemnizacion más TotalJubilacionPensionRetiro del nodo Percepciones.
    const { Percepciones = {} } = this.data;

    const total = parseFloat(Percepciones.TotalSueldos) + parseFloat(Percepciones.TotalSeparacionIndemnizacion) + parseFloat(Percepciones.TotalJubilacionPensionRetiro);

    return !isNaN(total) ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalDeducciones() {
    // Suma de los campos TotalOtrasDeducciones más TotalImpuestosRetenidos del Nodo Deducciones.
    const { Deducciones = {} } = this.data;

    const total = parseFloat(Deducciones.TotalOtrasDeducciones) + parseFloat(Deducciones.TotalImpuestosRetenidos);

    return !isNaN(total) ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalOtrosPagos() {
    const { OtrosPagos = {} } = this.data;
    const { OtroPago } = OtrosPagos;

    if (!OtroPago || OtroPago.length === 0) {
      return undefined;
    }

    const total = _.sumBy(OtroPago, (item) => {
      return parseFloat(item.Importe);
    });

    return !isNaN(total) ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

}

export default NominaTotalesCalculator;